module.exports = __webpack_public_path__ + "static/media/rockWallSheetTop.e8f33342.png";